import { Analytics } from "@/types";

export interface DataLinkAttributes {
  "data-linktype"?: string;
  "data-linkdetail"?: string;
  "data-hover-details"?: string;
  "data-program"?: string;
  "data-campaign"?: string;
}

interface IDs {
  programId?: string;
  campaignId?: string;
}

export const getDataLinkAttributes = <T extends Analytics & IDs>(
  link?: T,
): DataLinkAttributes => ({
  "data-linktype": link?.dlt || undefined,
  "data-linkdetail": link?.dld || undefined,
  "data-hover-details": link?.dhd || undefined,
  "data-program": link?.programId || undefined,
  "data-campaign": link?.campaignId || undefined,
});
